// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-section {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  padding: 40px 0;
  position: relative;
}

.payment-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(212,175,55,0.05) 0%, transparent 100%);
  pointer-events: none;
}

.payment-card {
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  border: 1px solid rgba(212,175,55,0.2);
}

.payment-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.logo-a, .logo-h {
  font-weight: 900;
  font-size: 36px;
}

.logo-a {
  color: #1a1a1a;
  margin-right: 2px;
}

.logo-h {
  color: #d4af37;
  margin-right: 16px;
}

.brand-payment {
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #2d2d2d;
}

.payment-title {
  font-weight: 300;
  font-size: 28px;
  color: #2d2d2d;
  margin-bottom: 8px;
}

.payment-subtitle {
  color: #666;
  font-size: 16px;
  margin: 0;
}

.section-title {
  display: flex;
  align-items: center;
  color: #2d2d2d;
  margin-bottom: 24px;
  font-size: 18px;
}

.section-icon {
  color: #d4af37;
  margin-right: 12px;
  font-size: 20px;
}

.form-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #2d2d2d;
  margin-bottom: 12px;
}

.input-icon {
  color: #d4af37;
  margin-right: 8px;
}

.card-element-container {
  margin-bottom: 32px;
}

.stripe-element {
  background: rgba(255,255,255,0.8);
  border: 2px solid rgba(212,175,55,0.2);
  border-radius: 12px;
  padding: 16px 20px;
  transition: all 0.3s ease;
}

.stripe-element:focus-within {
  border-color: #d4af37;
  box-shadow: 0 0 0 3px rgba(212,175,55,0.1);
}

.payment-btn {
  width: 100%;
  background: linear-gradient(45deg, #d4af37, #b8860b);
  border: none;
  border-radius: 12px;
  padding: 18px 24px;
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.payment-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(212,175,55,0.4);
}

.payment-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.amount-display {
  background: rgba(26,26,26,0.1);
  padding: 4px 12px;
  border-radius: 8px;
  font-weight: 600;
}

.order-summary {
  background: rgba(26,26,26,0.05);
  border-radius: 16px;
  padding: 24px;
  height: fit-content;
}

.summary-title {
  color: #2d2d2d;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 500;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(212,175,55,0.1);
}

.item-label {
  color: #666;
  font-size: 14px;
}

.item-value {
  color: #2d2d2d;
  font-weight: 500;
}

.item-value.amount {
  color: #d4af37;
  font-weight: 600;
  font-size: 16px;
}

.security-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: rgba(39,174,96,0.1);
  border: 1px solid rgba(39,174,96,0.2);
  border-radius: 12px;
  padding: 16px;
  margin-top: 24px;
}

.security-icon {
  color: #27ae60;
  font-size: 20px;
  margin-top: 2px;
}

.security-text strong {
  color: #27ae60;
  display: block;
  margin-bottom: 4px;
}

.security-text p {
  color: #666;
  font-size: 12px;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/payment/payment.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8EAA8E;EAC9E,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,oDAAoD;EACpD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX","sourcesContent":[".payment-section {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n  padding: 40px 0;\n  position: relative;\n}\n\n.payment-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, rgba(212,175,55,0.05) 0%, transparent 100%);\n  pointer-events: none;\n}\n\n.payment-card {\n  background: rgba(255,255,255,0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.3);\n  border: 1px solid rgba(212,175,55,0.2);\n}\n\n.payment-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.logo-a, .logo-h {\n  font-weight: 900;\n  font-size: 36px;\n}\n\n.logo-a {\n  color: #1a1a1a;\n  margin-right: 2px;\n}\n\n.logo-h {\n  color: #d4af37;\n  margin-right: 16px;\n}\n\n.brand-payment {\n  font-size: 18px;\n  font-weight: 300;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  color: #2d2d2d;\n}\n\n.payment-title {\n  font-weight: 300;\n  font-size: 28px;\n  color: #2d2d2d;\n  margin-bottom: 8px;\n}\n\n.payment-subtitle {\n  color: #666;\n  font-size: 16px;\n  margin: 0;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  color: #2d2d2d;\n  margin-bottom: 24px;\n  font-size: 18px;\n}\n\n.section-icon {\n  color: #d4af37;\n  margin-right: 12px;\n  font-size: 20px;\n}\n\n.form-label {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  color: #2d2d2d;\n  margin-bottom: 12px;\n}\n\n.input-icon {\n  color: #d4af37;\n  margin-right: 8px;\n}\n\n.card-element-container {\n  margin-bottom: 32px;\n}\n\n.stripe-element {\n  background: rgba(255,255,255,0.8);\n  border: 2px solid rgba(212,175,55,0.2);\n  border-radius: 12px;\n  padding: 16px 20px;\n  transition: all 0.3s ease;\n}\n\n.stripe-element:focus-within {\n  border-color: #d4af37;\n  box-shadow: 0 0 0 3px rgba(212,175,55,0.1);\n}\n\n.payment-btn {\n  width: 100%;\n  background: linear-gradient(45deg, #d4af37, #b8860b);\n  border: none;\n  border-radius: 12px;\n  padding: 18px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #1a1a1a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.payment-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(212,175,55,0.4);\n}\n\n.payment-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.amount-display {\n  background: rgba(26,26,26,0.1);\n  padding: 4px 12px;\n  border-radius: 8px;\n  font-weight: 600;\n}\n\n.order-summary {\n  background: rgba(26,26,26,0.05);\n  border-radius: 16px;\n  padding: 24px;\n  height: fit-content;\n}\n\n.summary-title {\n  color: #2d2d2d;\n  margin-bottom: 20px;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.summary-item {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(212,175,55,0.1);\n}\n\n.item-label {\n  color: #666;\n  font-size: 14px;\n}\n\n.item-value {\n  color: #2d2d2d;\n  font-weight: 500;\n}\n\n.item-value.amount {\n  color: #d4af37;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.security-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: rgba(39,174,96,0.1);\n  border: 1px solid rgba(39,174,96,0.2);\n  border-radius: 12px;\n  padding: 16px;\n  margin-top: 24px;\n}\n\n.security-icon {\n  color: #27ae60;\n  font-size: 20px;\n  margin-top: 2px;\n}\n\n.security-text strong {\n  color: #27ae60;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.security-text p {\n  color: #666;\n  font-size: 12px;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
